import { h } from 'preact';
import Store from 'store/store';

import { getAllMedia } from 'utils/api';
import { joinClasses } from 'utils/utils';
// import formatDateTime from 'utils/formatDateTime';
import { deleteMedia, downloadAll, onFileInput, showMediaInUseError } from 'utils/media';
import { alert, confirm, toast } from 'utils/modal';
import { isVideoFile } from 'utils/assets';
import { showMediaViewer } from 'components/media/mediaViewer';

import List from 'components/list/list';
import Button from 'components/button/button';
import AddMedia from 'components/media/addMedia';
import IconUpload from 'components/icons/upload';

import s from 'components/list/mediaList.sss';

const cancel = e => e.preventDefault();

export default class MediaList extends List {
	s = s;

	get itemsSource() {
		// TODO: should these be in the store?
		return this.state.media || [];
	}

	get attributes() {
		if (this.state.groupedMedia && !this.state.activeGroup) {
			// grouped media (root)
			return {
				name: { name: 'Name', accessor: this.getItemName, required: true, render: this.renderListItemName },
				modified: { name: 'Modified', accessor: group => group.updated_at, type: 'datetime', default: 'Unknown' },
				count: { name: 'Items', accessor: group => group.items?.length || 0, render: (item, value) => `${value} item${value !== 1 ? 's' : ''}` },
			};
		}
		const commonAttributes = {
			name: { name: 'File Name', accessor: this.getItemName, required: true, render: this.renderListItemName },
			uploaded_at: { name: 'Date Uploaded', accessor: item => item.updated_at, type: 'datetime', default: 'Unknown' },
			media_type: { name: 'File Type', render: (item) => item.name?.includes('.') ? item.name.split('.').pop().toUpperCase() : 'Unknown' },
			size: { name: 'Size', accessor: item => +item.media_size || 0, render: (item, value) => this.calcFileSize(value) },
		};
		if (this.state.groupedMedia) {
			// grouped media (in a folder)
			return {
				name: commonAttributes.name,
				asset: { name: 'Asset', accessor: item => item.media_type },
				uploaded_at: commonAttributes.uploaded_at,
				media_type: commonAttributes.media_type,
				size: commonAttributes.size,
			};
		}
		// ungrouped media (all media)
		return {
			name: commonAttributes.name,
			group: { name: 'Page', accessor: this.getGroupName },
			uploaded_at: commonAttributes.uploaded_at,
			media_type: commonAttributes.media_type,
			size: commonAttributes.size,
		};
	}

	get availableFilters() {
		if (this.state.activeGroup) return null;
		return {
			hubsite: { name: 'Hubsite Media', run: item => Array.isArray(item.section) && item.section.length > 0 },
			movie: { name: 'Movie Media', run: item => Array.isArray(item.movie) && item.movie.length > 0 },
			unused: { name: 'Unused', run: item => (!Array.isArray(item.section) || item.section.length === 0) && (!Array.isArray(item.movie) || item.movie.length === 0) },
		};
	}

	get sortOptions() {
		if (this.state.groupedMedia && !this.state.activeGroup) {
			return ['modified', 'name'];
		}
		return ['name', 'uploaded_at', 'size'];
	}

	get defaultSort() {
		if (this.state.groupedMedia && !this.state.activeGroup) {
			return { sort: 'modified', sortDirection: 'desc' };
		}
		return { sort: 'uploaded_at', sortDirection: 'desc' };
	}

	unusedGroup = { id: 'unused', name: 'Unused' };

	constructor(props) {
		super(props);

		this.state = {
			...this.state,
			name: 'name',
			groupedMedia: true,
			activeGroup: null,
			media: [],
		};
		this.state = { ...this.state, ...this.defaultSort };

		this.updateFromURL = this.updateFromURL.bind(this);
		this.getGroupName = this.getGroupName.bind(this);
		this.updateMedia = this.updateMedia.bind(this);
		this.toggleGrouping = this.toggleGrouping.bind(this);
		this.goToAllMedia = this.goToAllMedia.bind(this);
		this.onDragEnter = this.onDragEnter.bind(this);
		this.onDragLeave = this.onDragLeave.bind(this);
		this.onDrop = this.onDrop.bind(this);
		// this.downloadAll = this.downloadAll.bind(this);
	}

	componentDidMount() {
		window.addEventListener('popstate', this.updateFromURL);
		Store.on('UPDATE_MEDIA', this.updateMedia);
		this.updateMedia();
		this.updateFromURL();
		this.updateListColumns();
	}

	componentWillUnmount() {
		Store.off('UPDATE_MEDIA', this.updateMedia);
		window.removeEventListener('popstate', this.updateFromURL);
	}

	async updateMedia(refresh = false) {
		if (refresh) this.setState({ media: [], activeGroup: null });
		const media = await getAllMedia();
		if (media) this.setState({ media });
	}

	getTitle() {
		return this.props.title || 'Media';
	}

	getDescription() {
		return "View all your site's media";
	}

	calcFileSize(size) {
		if (!+size) return 'Unknown';
		const units = ['TB', 'GB', 'MB', 'KB', 'bytes'];
		let unit = units.pop();
		let fileSize = +size;
		while (fileSize >= 1024 && units.length) {
			fileSize /= 1024;
			unit = units.pop();
		}
		return `${fileSize.toLocaleString(undefined, { maximumFractionDigits: 2 })} ${unit}`;
	}

	updateListColumns() {
		this.setState({ columns: Object.fromEntries(Object.keys(this.attributes).map(key => [key, true])) });
	}

	toggleGrouping(e) {
		const groupedMedia = e.target.checked;
		this.setState({ groupedMedia, activeGroup: null });
		this.updateListColumns();
		this.updateURL();
	}

	goToAllMedia() {
		this.setState({ columns: { name: true, modified: true, count: true }, activeGroup: null });
		this.updateURL();
	}

	selectGroup(group) {
		this.setState({ filters: [], activeGroup: group });
		this.updateListColumns();
		this.updateURL();
	}

	updateURL() {
		const parts = [
			'media',
			this.state.groupedMedia && this.state.activeGroup?.id,
			!this.state.groupedMedia && 'all',
		].filter(Boolean);
		const hash = `#${parts.join('/')}`;
		if (location.hash !== hash) {
			this.manualURLUpdate = true;
			location.hash = hash;
			this.manualURLUpdate = false;
		}
	}

	updateFromURL() {
		if (this.manualURLUpdate) return;
		const [media, group] = location.hash.slice(1).split('/');
		if (media !== 'media') return;
		const desiredGroupedMedia = group !== 'all';
		const desiredGroupObject = this.findGroup(group && desiredGroupedMedia ? group : null);
		if (this.state.groupedMedia !== desiredGroupedMedia || this.state.activeGroup?.id !== desiredGroupObject?.id) {
			this.setState({ groupedMedia: desiredGroupedMedia, activeGroup: desiredGroupObject });
		}
	}

	getItems() {
		let items = this.itemsSource;
		// if there's a specified folder, filter items by that folder
		if (!items) return [];
		if (this.state.groupedMedia) {
			if (!this.state.activeGroup) {
				items = this.sortMediaIntoGroups(items);
			} else {
				// const { movies, pages } = Store.get().data || {};
				items = items.filter(item => {
					if (this.state.activeGroup.id === 'unused') {
						return (!Array.isArray(item.section) || item.section.length === 0) && (!Array.isArray(item.movie) || item.movie.length === 0);
					}

					// const allIds = [...item.section, ...item.movie].map(obj => obj.id);
					// return allIds.includes(this.state.activeGroup);
					return (
						(Array.isArray(item.section) && item.section.some(s => s.id === this.state.activeGroup.id))
						|| (Array.isArray(item.movie) && item.movie.some(m => m.id === this.state.activeGroup.id))
					);
				});
			}
		}
		return super.getItems(items);
	}

	getItemImage(item) {
		return item.s3_url;
	}

	search(item) {
		if (!this.state.search) return true;
		const searchLower = this.state.search.toLowerCase();
		if (this.state.groupedMedia && !this.state.activeGroup) {
			// if media grouped: search grouped images to see if any match search term
			if (item.items?.some(item => item.name?.toLowerCase().includes(searchLower))) {
				return true;
			}
		} else {
			// if singular media: check if associated page/movie matches search term
			const groups = this.getGroups(item);
			if (groups.some(group => group.name?.toLowerCase().includes(searchLower))) {
				return true;
			}
		}
		return super.search(item);
	}

	getAllGroups() {
		const { movies, pages } = Store.get().data || {};
		return [
			...Object.values(pages || {}).map(p => ({ id: p.id, name: p.name })),
			...Object.values(movies || {}).map(m => ({ id: m.id, name: m.content?.title || m.base_movie?.content?.title })),
		];
	}

	findGroup(id) {
		if (!id) return null;
		if (id === 'unused') return this.unusedGroup;
		return this.getAllGroups().find(g => g.id === id) || null;
	}

	getGroupName(item) {
		const groups = this.getGroups(item);
		return (groups[0]?.name || '') + (groups.length > 1 ? ` (and ${groups.length - 1} more)` : '');
	}

	getGroups(item) {
		const inGroups = [].concat(item.section, item.movie).map(o => o?.id);
		const groups = this.getAllGroups().filter(group => inGroups.includes(group.id));

		return groups.length ? groups : [this.unusedGroup];
	}

	sortMediaIntoGroups(items) {
		const groups = items.reduce((groups, item) => {
			const itemTimestamp = item.updated_at || item.uploaded_at || item.uploadAt || Date.now();
			const at = itemTimestamp instanceof Date ? itemTimestamp : new Date(itemTimestamp);

			let addedToGroup = false; // track if the item has been added to any group
			const addToGroup = (groupId, groupData) => {
				if (!groups[groupId]) {
					groups[groupId] = { ...groupData, items: [], updated_at: at };
				}
				if (groups[groupId].updated_at < at) {
					groups[groupId].updated_at = at;
				}
				groups[groupId].items.push(item);
				addedToGroup = true;
			};

			// Process sections
			if (Array.isArray(item.section) && item.section.length > 0) {
				item.section.forEach(({ id, name }) => addToGroup(id, { id, name, section: item.section }));
			}

			// Process movies
			if (Array.isArray(item.movie) && item.movie.length > 0) {
				item.movie.forEach(({ id, title }) => addToGroup(id, { id, name: title, movie: item.movie }));
			}

			// Handle unused items (no sections or movies)
			if (!addedToGroup) {
				addToGroup('unused', { id: 'unused', name: 'Unused' });
			}

			return groups;
		}, {});

		return Object.values(groups);
	}
	onDragEnter(e) {
		e.preventDefault();
		this.setState({ dragging: true });
	}
	onDragLeave() {
		this.setState({ dragging: false });
	}
	onDrop(e) {
		e.preventDefault();
		this.setState({ dragging: false });
		onFileInput(e.dataTransfer.files, this.state.groupedMedia && this.state.activeGroup?.id || null);
	}

	async onDeletedFileInUse(id, res) {
		try {
			await showMediaInUseError(await res.json(), id);
		} catch {}
	}

	async onDeleteMediaClick(id, e) {
		const ok = await confirm('This will permanently delete the file and cannot be undone', { title: 'Delete file?', danger: true, button: 'Delete file' });
		if (!ok) return;
		try {
			const force = !!e.shiftKey;
			await deleteMedia(id, { force });
		} catch (err) {
			if (err?.code === 409) {
				return this.onDeletedFileInUse(id, err.response);
			}
			// The server error is not very user-friendly, do not show its message in the toast
			console.error(err);
			toast(`Error deleting file`, { icon: 'alert' });
		}
	}

	onItemClick(item) {
		return showMediaViewer(item);
	}

	renderSettingsButtons() {
		return <AddMedia group={this.state.groupedMedia && this.state.activeGroup?.id || null} />;
	}

	renderBreadcrumbs() {
		if (!this.state.activeGroup) return;
		return (
			<div class={s.breadcrumbs}>
				<button onClick={this.goToAllMedia}>All media</button>
				<div class={s.current}>{this.state.activeGroup.name}</div>
			</div>
		);
	}

	renderViewModeOptions() {
		return [
			{
				content: (
					<Button tag="label" class={s.columnToggler}>
						<input type="checkbox" value={this.state.groupedMedia} checked={this.state.groupedMedia} onChange={this.toggleGrouping} />
						Group media
					</Button>
				),
			},
		];
	}

	renderFileDropper() {
		return (
			<div class={joinClasses(s.dropZone, this.state.dragging && s.active)} onDragOver={cancel} onDragLeave={this.onDragLeave} onDrop={this.onDrop}>
				<div class={s.dropZoneContent}>
					<IconUpload />
					Drop files to upload
				</div>
			</div>
		);
	}

	renderAsset(item) {
		if (!this.state.groupedMedia || this.state.activeGroup) {
			const src = this.getItemImage(item);
			if (isVideoFile(item.name)) {
				return (
					<button class={s.preview} onClick={() => this.onItemClick(item)}>
						<video class={s.video} src={src} />
					</button>
				);
			}
			return <button class={s.preview} style={src ? `--image: url('${src}')` : ''} onClick={() => this.onItemClick(item)} />;
		}
		const preview = item.items.slice(0, 4);
		return (
			<div class={s.assetsGroup} onClick={() => this.selectGroup(item)} data-extra-items={item.items.length - preview.length}>
				{preview.map(item => {
					const src = this.getItemImage(item);
					if (isVideoFile(item.name)) {
						return <video class={s.groupAsset} src={src} />;
					}
					return <div class={s.groupAsset} style={src ? `--image: url('${src}')` : ''} />;
				})}
			</div>
		);
	}

	renderGridPreview(item) {
		return this.renderAsset(item);
	}

	renderGridItemName(item) {
		if (this.state.groupedMedia && !this.state.activeGroup) {
			return <button onClick={() => this.selectGroup(item)}>{item.name}</button>;
		}
		return <button onClick={() => this.onItemClick(item)}>{this.getItemName(item)}</button>;
	}

	renderGridItemSubName(item) {
		if (this.state.groupedMedia && !this.state.activeGroup) {
			return `${item.items?.length || 0} item${item.items?.length !== 1 ? 's' : ''}`;
		}
		// return this.getGroups(item)[0]?.name;
		return this.getGroupName(item);
	}

	renderGridItemDetails(item) {
		if (this.state.groupedMedia && !this.state.activeGroup) return;

		const uploadDate = item.updated_at instanceof Date ? item.updated_at : new Date(item.updated_at);
		return (
			<div class={s.details}>
				{!!uploadDate && (
					<div class={s.detail} key="upload-date">
						<div class={s.label}>Uploaded</div>
						{this.renderTimeInfo(uploadDate, 'Unknown')}
					</div>
				)}
				{!!item.media_size && (
					<div class={s.detail} key="size">
						<div class={s.label}>File size</div>
						<div>{this.calcFileSize(item.media_size)}</div>
					</div>
				)}
			</div>
		);
	}

	renderListItemName(item) {
		if (this.state.groupedMedia && !this.state.activeGroup) {
			return (
				<button class={s.listMediaAssetsGroup} onClick={() => this.selectGroup(item)}>
					{this.renderAsset(item)}
					{item.name}
				</button>
			);
		}
		return (
			<button onClick={() => this.onItemClick(item)} class={s.nameAsset}>
				{this.renderAsset(item)}
				{this.getItemName(item)}
			</button>
		);
	}

	renderItemMenuElements(item) {
		if (this.state.groupedMedia && !this.state.activeGroup) {
			return [<Button icon="download" onClick={() => downloadAll(item)}>Download All</Button>];
		}
		return [
			<Button icon="download" class={s.downloadLink} href={item.s3_url} download={item.name} target="_blank">Download</Button>,
			<Button text danger icon="cancel" onClick={(e) => this.onDeleteMediaClick(item.id, e)}>Delete Media</Button>
		];
	}

	renderExtraHeaderContent() {
		return [
			this.renderSettings(),
			this.renderBreadcrumbs(),
			this.state.viewMode === 'grid' && this.renderGridSortOptions(),
		];
	}

	render() {
		const base = super.render(...arguments);
		if (base?.attributes) {
			base.attributes.onDragEnter = this.onDragEnter;
		}
		if (base?.children) {
			base.children.push(this.renderFileDropper());
		}
		return base;
	}
}